import * as analytics from '../../vendor/analytics/index';
import { getUserType } from './authUtils';
import _includes from 'lodash/includes';

export function trackWizardStep(data) {
  const pageType = getPageType();
  const stepNum = data.step;

  trackPageWithData(
    `main:wps:donate:button:setup:wizard:${pageType}:${stepNum}`,
    `main:wps:donate:button:setup:wizard:${pageType}:${stepNum}`,
    data
  );
}

export function trackWizardDetailsPage(data) {
  const pageType = getPageType();
  const tab = data.tab;

  trackPageWithData(
    `main:wps:donate:button:setup:details:${pageType}:${tab}`,
    `main:wps:donate:button:setup:details:${pageType}:${tab}`,
    data
  );
}

function getPageType() {
  const isHosted = _includes(['BUSINESS', 'PREMIER'], getUserType());
  return isHosted ? 'hosted' : 'unhosted';
}

export function trackPageWithData(pageGroup, pageName, data) {
  analytics.trackPageWithData(pageGroup, pageName, data);
}

export function trackLinkClick(linkName, pageGroup, pageName) {
  analytics.trackLink(linkName, pageGroup, pageName, 'link');
}

export function trackErrorImpressionWithData(data) {
  const { pgrp, page } = window.fpti;
  analytics.trackErrorWithData(pgrp, page, data);
}
